import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitBooking(payload) {
  const { data } = await api.post("/bookings", payload);
  return data;
}
